import styled from 'styled-components';

export const RowsWrapper = styled.div`
    width: 100%;
`;
